import {
  dimensiondata_1_tetelek_group_1_2_3_4_row,
  dimensiondata_1_tetelek_group_row,
  dimensiondata_2_termekek_group_1_2_column,
  dimensiondata_2_termekek_group_column,
  terajoule_value_1_data_precision,
  terajoule_value_1_data_precision_no_year_summary,
  year_column_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const evesMegujuloMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {numberOfYears: 1},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EvesMegujuloMerleg',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_1_2_3_4_row,
      year_column_expanded,
      ...dimensiondata_2_termekek_group_1_2_column,
      terajoule_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
